
import Link from "next/link";
import React from "react";

const Breadcrumbs = ({ context, index }) => {
  return context.showBc && index === 0 && <div className="fil-text pt-5 mb-5">
    {
      context.bc.map((item, i) => {
        return <React.Fragment key={i}>
          <Link href={item.url}> {item.name} </Link>{'>'}
        </React.Fragment>
      })
    }
    <span> {context.pageName} </span>
  </div>

}

export default Breadcrumbs